export default __webpack_public_path__ + "static/media/Orioles.75b45b44.png";